import { Component, OnInit } from '@angular/core';
import { IncomevsExpenseCommonChartHandler } from './income-vs-expense.handler.';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-income-vs-expense-common',
  templateUrl: './income-vs-expense.component.html',
  styleUrls: ['./income-vs-expense.component.scss'],
})
export class IncomevsExpenseCommonChartComponent extends IncomevsExpenseCommonChartHandler {
  constructor(public service: DashboardService, public settingService: SettingService) {
    super(service, settingService);
  }
}
